module.exports = __webpack_public_path__ + "static/img/game-3.924fb72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game-3.png
// module id = VooA
// module chunks = 1